import { render, staticRenderFns } from "./HelpDetail.vue?vue&type=template&id=6ba1c15d&"
import script from "./HelpDetail.vue?vue&type=script&lang=ts&"
export * from "./HelpDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports